import { Avatar, Image, Menu, MenuButton, MenuItem, MenuList, Text } from '@chakra-ui/react';
import { LangKey, LangsFlags } from '../../../intl';
import { useIntl } from '../../../state/intl';

interface LanguagePickerProps {}

const LanguagePicker: React.FC<LanguagePickerProps> = () => {
  const { lang, setLang } = useIntl();

  const txs: {
    [key in LangKey]: {
      langs: {
        [key in LangKey]: string;
      };
    };
  } = {
    en: {
      langs: {
        it: 'Italian',
        en: 'English',
        es: 'Spanish',
      },
    },
    it: {
      langs: {
        it: 'Italiano',
        en: 'Inglese',
        es: 'Spagnolo',
      },
    },
    es: {
      langs: {
        it: 'Italian',
        en: 'English',
        es: 'Spanish',
      },
    },
  };

  const tx = txs[lang];

  const langsMenuItems = Object.keys(LangsFlags).map(key => (
    <MenuItem h="40px" key={key} isDisabled={lang === key} onClick={() => setLang(key as LangKey)}>
      <Image
        mr="16px"
        ml={1}
        borderRadius="full"
        w="22px"
        h="22px"
        alt={key}
        src={LangsFlags[key as LangKey]}
      />
      <Text color="gray.700">{tx.langs[key as LangKey]}</Text>
    </MenuItem>
  ));

  return (
    <Menu placement="bottom-end">
      <MenuButton as={Avatar} w="24px" h="24px" cursor="pointer" src={LangsFlags[lang]} />
      <MenuList>{langsMenuItems}</MenuList>
    </Menu>
  );
};

export default LanguagePicker;
